<template>
    <v-container>
        <v-navigation-drawer
                v-model="drawer"
                app
        >
            <v-list dense>
                <v-list-item link>
                    <v-list-item-action>
                        <v-icon>mdi-home</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Home</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link>
                    <v-list-item-action>
                        <v-icon>mdi-email</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Contact</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <v-app-bar
                app
                color="#64d2ff"
                dark
        >
            <div class="d-flex align-center">
                <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
                <v-toolbar-title>
                    <router-link to="/">
                        #enishi
                    </router-link>
                </v-toolbar-title>
            </div>
            <v-spacer></v-spacer>
            <Logout></Logout>

        </v-app-bar>
        <v-main>
            <v-container
                    class="fill-height"
                    fluid
            >
                <v-row
                        align="center"
                        justify="center"
                >
                    <v-col cols="12">
                        <WeekCalendar></WeekCalendar>
                    </v-col>
                    <v-col cols="12" class="grey  lighten-5">
                        <v-card
                                class="mx-auto"
                                max-width="344"
                                outlined
                        >
                            <v-list-item three-line>
                                <v-list-item-avatar
                                        size="80"
                                        color="grey"
                                ></v-list-item-avatar>
                                <v-list-item-content>
                                    <div class="overline mb-4">8月27日(木) 17:00～21:00  3名</div>
                                    <v-list-item-title class="headline mb-1">とんこつラーメンきくや</v-list-item-title>
                                    <v-list-item-subtitle>夜間限定 皿洗いのお手伝い募集</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-card-actions class=""
                            >
                                <v-btn
                                        class="primary v-btn--flat"
                                >
                                    詳細をみる
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                        <v-card
                                class="mx-auto"
                                max-width="344"
                                outlined
                        >
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <div class="overline mb-4">OVERLINE</div>
                                    <v-list-item-title class="headline mb-1">Headline 5</v-list-item-title>
                                    <v-list-item-subtitle>Greyhound divisely hello coldly fonwderfully</v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-avatar
                                        tile
                                        size="80"
                                        color="grey"
                                ></v-list-item-avatar>
                            </v-list-item>

                            <v-card-actions>
                                <v-btn text>Button</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
        <v-bottom-navigation
                app
                :value="activeBtn"
                grow
                color="teal"
        >
            <v-btn>
                <span>見つける</span>
                <v-icon>mdi-magnify</v-icon>
            </v-btn>

            <v-btn>
                <span>集める</span>
                <v-icon>mdi-file-edit</v-icon>
            </v-btn>

            <v-btn>
                <span>イベント</span>
                <v-icon>mdi-calendar-month-outline</v-icon>
            </v-btn>
            <v-btn>
                <span>マイページ</span>
                <v-icon>mdi-account-box</v-icon>
            </v-btn>
        </v-bottom-navigation>
    </v-container>
</template>

<script>
    import Logout from '@/components/Logout';
    import WeekCalendar from '@/components/WeekCalendar';


    export default {
        name: 'Home',
        components: {
            Logout,
            WeekCalendar
        }
    }
</script>

<style scoped>
    .v-toolbar__title a {
        text-decoration: none;
        color: #fff;
    }
</style>
